
export default function ExploreSkiTrikke() {
  return (
    <section id="ski-trikke-explore" className="w-full py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12 md:mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-7xl font-thin tracking-wider text-gray-900"
            style={{ letterSpacing: '2px' }}
          >
            SKKI TRIKKE
          </h2>
          <p className="text-base md:text-lg font-light text-gray-600 md:max-w-xs leading-relaxed">
            Châtel's first dedicated Skki Trikke Hub — the most inclusive, stable, and thrilling way to carve the Portes du Soleil.
          </p>
        </div>

        {/* Feature Card */}
        <div
          className="group rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer flex flex-col lg:flex-row-reverse"
          style={{ backgroundColor: '#F0EDE8' }}
        >
          {/* Image */}
          <div className="w-full lg:w-3/5 h-72 sm:h-96 lg:h-auto min-h-[320px] overflow-hidden relative bg-gray-100">
            <img
              src="https://skki-trikke.eu/wp-content/uploads/2021/08/20190401_133644_szyplinski_500_7284-300x300.jpg"
              alt="Skki Trikke device on the slopes of Châtel"
              className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute top-4 left-4 flex flex-col gap-2">
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase shadow-lg"
                style={{ backgroundColor: '#D4AF37', color: '#1A2332' }}
              >
                <i className="ri-award-fill text-sm"></i>
                Châtel's First Hub
              </div>
              <div
                className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium tracking-wide shadow-lg"
                style={{ backgroundColor: 'rgba(26,35,50,0.85)', color: '#ffffff' }}
              >
                <i className="ri-shield-check-line text-sm"></i>
                2027 Fleet · STRMTG Certified
              </div>
            </div>
          </div>

          {/* Details */}
          <div className="w-full lg:w-2/5 p-6 md:p-10 lg:p-12 flex flex-col justify-center">
            <div
              className="flex items-start gap-3 p-4 rounded-xl mb-6 border"
              style={{ backgroundColor: '#FFF8E7', borderColor: '#D4AF37' }}
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-lg" style={{ color: '#D4AF37' }}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800 mb-1">Signature "Mise en Main" Included</p>
                <p className="text-xs font-light text-gray-600 leading-relaxed">
                  Every rental includes a mandatory 15-minute professional orientation — ensuring you are fully confident before heading to the Gabelou or Portes du Soleil links.
                </p>
              </div>
            </div>

            <h3
              className="text-3xl md:text-4xl font-medium mb-4 text-gray-900"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Discover the Slopes with Confidence
            </h3>

            <p className="text-base font-light text-gray-600 mb-6 leading-relaxed">
              Located in the heart of the Vonnes sector, our exclusive hub gives you seamless access to the lift network with the latest 2027 Skki Trikke fleet — maintained to the highest professional standards.
            </p>

            {/* Key Features */}
            <div className="mb-8">
              <h4 className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">Why Rent With Us</h4>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: 'ri-map-pin-2-line', label: 'Prime Location' },
                  { icon: 'ri-shield-check-line', label: 'Safety First' },
                  { icon: 'ri-group-line', label: 'All Ages Welcome' },
                  { icon: 'ri-star-line', label: 'Regional Exclusive' },
                  { icon: 'ri-tools-line', label: '2027 Fleet' },
                  { icon: 'ri-time-line', label: '15-Min Orientation' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-2.5">
                    <div
                      className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0"
                      style={{ backgroundColor: '#FFF8E7' }}
                    >
                      <i className={`${item.icon} text-sm`} style={{ color: '#D4AF37' }}></i>
                    </div>
                    <span className="text-sm font-light text-gray-600 whitespace-nowrap">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <a
              href="/ski-trikke"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-sm font-medium tracking-widest uppercase transition-all duration-300 hover:opacity-90 self-start whitespace-nowrap"
              style={{ backgroundColor: '#1A2332', color: '#D4AF37' }}
            >
              Explore Skki Trikke
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
